<!--  -->
<template>
  <div class="re_box">
    <el-card class="box-card">
      <!-- 选择区 -->
      <div class="selectionArea">
        <div class="item">
          <!-- <el-input
            v-model="query.name"
            style="width: 300px;"
            placeholder="名称"
          /> -->
        </div>
        <!-- <div class="item">
          <el-select
            v-model="query.status"
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div> -->
        <div class="item">
          <!-- <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            @click="search"
          >搜索</el-button>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button> -->
          <el-button
            size="mini"
            type="success"
            icon="el-icon-s-help"
            @click="creater"
          >创建</el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        max-height="500"
      >
        <el-table-column
          prop="type"
          label="ID"
          width="100"
          align="center"
        />
        <el-table-column
          prop="name"
          label="名称"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <el-button
              type="primary"
              size="mini"
              @click="edit(scope.row)"
            >编辑</el-button> -->
            <el-button
              type="danger"
              size="mini"
              @click="bandwechat(scope.row.type)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
    </el-card>
    <el-dialog
      title="新增名称"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleClose"
    >
      <span>
        <el-input
          v-model="name"
          placeholder="请输入内容"
        />
      </span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="sumbier"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { reviewedlinklist, reviewedlinkdelete, reviewedlinkcreate } from '@/api/customer'
// import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    /* PaginationRight */
  },
  data() {
    return {
      name: '',
      query: {
        page: 1,
        page_size: 10,
        name: '',
        status: ''
      },
      tableData: [],
      total: null,
      dialogVisible: false,
      options: [
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '下架'
        }
      ]
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    async list() {
      const data = await reviewedlinklist(this.query)
      this.tableData = data.data
      // this.total = data.data.total
      console.log('data', data)
    },
    search() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.name = ''
      this.query.status = ''
      this.query.created_at = ''
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },

    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    creater() {
      this.dialogVisible = true
      // this.$nextTick(() => {
      //   this.$refs.returndialogview.send(1)
      // })
    },
    updata() {
      this.dialogVisible = false
      this.list()
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.returndialogview.send(2, item)
      })
    },
    bandwechat(type) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          reviewedlinkdelete({
            type: type
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.list()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    async sumbier() {
      this.dialogVisible = true
      if (this.name === '') {
        this.$message({
          message: '请填写名称',
          type: 'danger'
        })
        return
      }
      const data = await reviewedlinkcreate({
        name: this.name
      })
      this.$message({
        message: '创建成功',
        type: 'success'
      })
      this.dialogVisible = false
      this.list()
      console.log('data', data)
    },
    handleClose() {
      this.name = ''
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.re_box {
  padding: 30px;
}
.channelManagement {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  /* flex-wrap: wrap; */
  /* justify-content: space-between; */
  justify-content: flex-end;
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(33.33% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
</style>
